/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ShippingInfo from '../../../components/Web/ReviewOrderPage/FunctionalRedesign/shippingInfo';
import * as reviewOrderActions from '../actions';
import * as cartActions from '../../../services/Cart/actions';
import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import saga from '../sagas';
import taggingSaga from '../../Common/Tagging.js/sagas';

import reviewOrder from '../reducer';
import {
  plansReferenceData,
  securePinDataDeviceSucess,
  getSmsSuccess,
  securePinData,
  shippingInfoState,
  shippingInfoDetails,
  commonData,
  isInvalidOTP,
  isInvalidAddressError,
  updateShippingAdressResponse,
  updateValidateOTPResponse,
} from './Common';

const mapStateToProps = (state) => {
  const reviewOrderState = state.reviewOrder;
  const shippingState = state.termsAndConditions || {};
  const marketDetails = state.termsAndConditions.marketDetails || {};
  const promos = state.reviewOrder ? state.reviewOrder.promos : {};
  const currentView = state.currentView || {};

  const paymentDetails = state?.checkout?.lineDetails?.payments;
  const payments = [];
  if (paymentDetails) {
    Object.keys(paymentDetails).forEach((data) => {
      const payment = paymentDetails[data];
      payments.push(payment);
    });
  }
  const totalDueToday = state?.checkout?.orderDetails?.totalDueToday;
  const cartDetails = state?.checkout?.cart || {};
  const ISPUOpted = state?.checkout?.depletionType === 'L';
  const orderDetails = state?.checkout?.orderDetails;
  const shippingDescription = state?.checkout?.lineDetails?.lineInfo?.newLine1?.shippingItem?.description;
  const shippingAddress = state?.checkout?.lineDetails?.lineInfo?.newLine1?.shipping?.address;

  const setupType = state?.checkout?.depletionType;

  const { isMaxAttemptsExceeded } = state.termsAndConditions;
  const cart5GAddress = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.cart5GAddress;
  const storeInfo = state?.checkout?.lineDetails?.lineInfo?.newLine1?.shipping?.storeInfo;
  const billingAddress = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.primaryUserInfo?.address;

  return {
    shippingDescription,
    orderDetails,
    paymentDetails,
    totalDueToday,
    reviewOrderState,
    cartDetails,
    plansReferenceData,
    promoDetails: promos,
    currentView,
    showPaymentSelectOnEditClick: state.showPaymentSelectOnEditClick,
    marketDetails,
    shippingState,
    securePinDataDeviceSucess,
    getSmsSuccess,
    securePinData,
    shippingInfoState,
    commonData,
    shippingInfoDetails,
    isInvalidAddressError,
    isInvalidOTP,
    updateShippingAdressResponse,
    updateValidateOTPResponse,
    isMaxAttemptsExceeded,
    addressList: state?.cartDetails?.availableAddress ? state?.cartDetails?.availableAddress?.addresses : [],
    isEmptyAddress: state?.cartDetails?.isEmptyAddress || false,
    isPOBoxAddress: state?.cartDetails?.isPOBoxAddress || false,
    setupType,
    shippingAddress,
    payments,
    cart5GAddress,
    storeInfo,
    ISPUOpted,
    billingAddress,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...reviewOrderActions, ...cartActions }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'reviewOrder', reducer: reviewOrder }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(
  injectSaga({ key: 'tos', saga }),

  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(compose(withSaga, withReducer, withConnect)(ShippingInfo));
